export const COURIER_COMPANY: Record<string, { label: string; url: string }> = {
  CHUNILPS: {
    label: '천일택배',
    url: 'http://www.chunilps.co.kr/htmls/subPage.jsp?control=trace&pageNum=01',
  },
  CJ: {
    label: 'CJ대한통운',
    url: 'https://www.cjlogistics.com/ko/tool/parcel/tracking',
  },
  CUPOST: {
    label: 'CU 편의점 택배',
    url: 'https://www.cupost.co.kr/postbox/delivery/all.cupost',
  },
  CVSNET: {
    label: 'GS CVSnet 편의점택배',
    url: 'https://www.cvsnet.co.kr/reservation-inquiry/delivery/index.do',
  },
  DAESIN: {
    label: '대신 택배',
    url: 'http://www.ds3211.co.kr/freight/internalFreightForm.jsp',
  },
  EPOST: {
    label: '우체국',
    url: 'https://service.epost.go.kr/iservice/usr/trace/usrtrc001k01.jsp',
  },
  HANJIN: {
    label: '한진택배',
    url: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
  },
  HDEXP: {
    label: '합동택배',
    url: 'https://hdexp.co.kr/index.hd',
  },
  HONAM: {
    label: '한서호남택배',
    url: 'http://www.honamlogis.co.kr/page/?pid=tracking_number',
  },
  ILYANG: {
    label: '일양로지스',
    url: 'https://www.ilyanglogis.co.kr/board/board_delivery/tracking.asp',
  },
  KDEXP: {
    label: '경동택배',
    url: 'https://kdexp.com/index.do',
  },
  KUNYOUNG: {
    label: '건영택배',
    url: 'https://www.kunyoung.com/goods/goods_01.php',
  },
  LOGEN: {
    label: '로젠택배',
    url: 'https://www.ilogen.com/m/personal/tkSearch',
  },
  LOTTE: {
    label: '롯데택배',
    url: 'https://www.lotteglogis.com/mobile/reservation/tracking/index',
  },
};

export const DELIVERY_COMPANY: Record<string, string> = {
  CHUNILPS: '천일 택배',
  CJ: 'CJ대한통운',
  CUPOST: 'CU 편의점 택배',
  CVSNET: 'GS CVSnet 편의점택배',
  DAESIN: '대신 택배',
  EPOST: '우체국',
  HANJIN: '한진택배',
  HDEXP: '합동택배',
  HONAM: '한서호남택배',
  ILYANG: '일양로지스',
  KDEXP: '경동택배',
  KUNYOUNG: '건영택배',
  LOGEN: '로젠택배',
  LOTTE: '롯데택배',
  DIRECT: '직접배송',
};
